import { useCallback, useState } from "react";
import { useData } from "../context/DataContext";
import type { RevealSpec } from "../types";
import { trackEvent } from "../lib/analytics";

export function useReveal() {
  const [spec, setSpec] = useState<RevealSpec | null>(null);
  const { addHistory } = useData();

  const show = useCallback((s: Omit<RevealSpec, "nonce">) => {
    setSpec({ ...s, nonce: Date.now() + Math.random() });
    addHistory({ kind: s.kind, title: s.title, result: s.result, category: s.category });
    trackEvent("decision", { kind: s.kind, category: s.category });
  }, [addHistory]);

  const close = useCallback(() => setSpec(null), []);
  return { spec, show, close };
}
